import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";

interface BlockingFeaturesProps {
  blockingFeatures: string[];
  i18nRoot: string;
  isLoading?: boolean;
}

export const BlockingFeatures = ({
  blockingFeatures,
  i18nRoot,
  isLoading,
}: BlockingFeaturesProps) => {
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="dark:bg-primary mt-6 rounded-md bg-slate-50 px-6 py-5">
      {blockingFeatures.length > 0 ? (
        <>
          <Typography.BodyMd>
            {t(`${i18nRoot}.scheduled_downgrade.blocking_features_title`)}
          </Typography.BodyMd>
          <ul className="list-inside list-disc space-y-1 pl-2 pt-2">
            {blockingFeatures.map((feature: string) => (
              <li key={feature}>
                <span className="text-dark text-md font-normal normal-case leading-6 tracking-tighter">
                  {feature}
                </span>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <Typography.BodyMd>
          {t(`${i18nRoot}.scheduled_downgrade.no_blocking_features`)}
        </Typography.BodyMd>
      )}
    </div>
  );
};
